import posthog, { PostHog } from 'posthog-js';
import { PosthogFeatureFlags } from '@domgen/shared/enums/featureFlags';
import { GaEventData } from '../../models/store/gaEventData';

type LandingPageExperiment = Pick<GaEventData, 'experimentName' | 'experimentVariant'>;

const landingPageVariants: unknown[] = ['control', 'test'];

/**
 * @description Returns the brand desktop landing page experiment (KitchenAid, Whirlpool) the user is in, for GA tagging.
 * The brand flags are read in the same order as in `isLandingPageJourney`, so users already on the landing page journey
 * (mobile and tablet) are never exposed to the brand desktop experiments and get no experiment here.
 *
 * @param {Pick<PostHog, 'getFeatureFlag'>} [client] - The PostHog client to read the flags from, defaults to the posthog-js instance.
 * @returns {LandingPageExperiment} The flag key and variant, or an empty object when the user is not in a brand desktop experiment.
 */
export const getLandingPageExperiment = (
  client: Pick<PostHog, 'getFeatureFlag'> = posthog,
): LandingPageExperiment => {
  if (client.getFeatureFlag(PosthogFeatureFlags.LANDING_PAGE) === 'test') return {};

  for (const flag of [
    PosthogFeatureFlags.LANDING_PAGE_KHAID,
    PosthogFeatureFlags.LANDING_PAGE_WHIRL,
  ]) {
    const variant = client.getFeatureFlag(flag);
    if (typeof variant === 'string' && landingPageVariants.includes(variant)) {
      return { experimentName: flag, experimentVariant: variant };
    }
  }

  return {};
};
